{
  "level": "mt06mov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt06mov",
    "objects": "AREAS.E3:mt06mov.e3",
    "mesh": "TREES.E3:mt06mov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -0.0,
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        0.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: cdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "cdr1",
      "offset": 552,
      "centroid": [
        -318.0,
        -2235.5,
        645.0
      ],
      "bbox_min": [
        -324.0,
        -2236.5,
        638.0
      ],
      "bbox_max": [
        -312.0,
        -2234.5,
        652.0
      ],
      "dimensions_source": {
        "span_x": 12.0,
        "span_y": 2.0,
        "height_z": 14.0,
        "door_width": 12.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -324.0,
          -2236.5,
          638.0
        ],
        [
          -324.0,
          -2234.5,
          652.0
        ],
        [
          -324.0,
          -2236.5,
          652.0
        ],
        [
          -324.0,
          -2234.5,
          638.0
        ],
        [
          -312.0,
          -2236.5,
          638.0
        ],
        [
          -312.0,
          -2234.5,
          652.0
        ],
        [
          -312.0,
          -2236.5,
          652.0
        ],
        [
          -312.0,
          -2234.5,
          638.0
        ]
      ],
      "plane_distance": 638.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: cdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "cdr2",
      "offset": 1573,
      "centroid": [
        -374.67718505859375,
        -2320.3241577148438,
        645.0010986328125
      ],
      "bbox_min": [
        -378.128173828125,
        -2326.345703125,
        638.002197265625
      ],
      "bbox_max": [
        -371.226318359375,
        -2314.302490234375,
        652.0
      ],
      "dimensions_source": {
        "span_x": 6.90185546875,
        "span_y": 12.043212890625,
        "height_z": 13.997802734375,
        "door_width": 12.043212890625,
        "door_depth": 6.90185546875,
        "leaf_depth": 6.86185546875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -378.128173828125,
          -2315.25927734375,
          638.002197265625
        ],
        [
          -378.128173828125,
          -2315.25927734375,
          652.0
        ],
        [
          -373.535888671875,
          -2326.345703125,
          652.0
        ],
        [
          -373.535888671875,
          -2326.345703125,
          638.002197265625
        ],
        [
          -375.818359375,
          -2314.302490234375,
          652.0
        ],
        [
          -375.818359375,
          -2314.302490234375,
          638.002197265625
        ],
        [
          -371.226318359375,
          -2325.38916015625,
          638.002197265625
        ],
        [
          -371.226318359375,
          -2325.38916015625,
          652.0
        ]
      ],
      "plane_distance": 638.0022,
      "authentic_texture": "slidedoor3"
    },
    {
      "tag": "CSlidingDoor piece: cdr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "cdr3",
      "offset": 2628,
      "centroid": [
        -261.32281494140625,
        -2320.3241577148438,
        645.0010986328125
      ],
      "bbox_min": [
        -264.773681640625,
        -2326.345703125,
        638.0
      ],
      "bbox_max": [
        -257.871826171875,
        -2314.302490234375,
        652.002197265625
      ],
      "dimensions_source": {
        "span_x": 6.90185546875,
        "span_y": 12.043212890625,
        "height_z": 14.002197265625,
        "door_width": 12.043212890625,
        "door_depth": 6.90185546875,
        "leaf_depth": 6.86185546875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -0.0008,
          0.0003,
          -1.0
        ]
      },
      "vertices": [
        [
          -262.464111328125,
          -2326.345703125,
          652.0
        ],
        [
          -257.871826171875,
          -2315.25927734375,
          652.0
        ],
        [
          -257.871826171875,
          -2315.25927734375,
          638.0
        ],
        [
          -262.464111328125,
          -2326.345703125,
          638.0
        ],
        [
          -260.181640625,
          -2314.302490234375,
          652.002197265625
        ],
        [
          -264.773681640625,
          -2325.38916015625,
          652.002197265625
        ],
        [
          -264.773681640625,
          -2325.38916015625,
          638.002197265625
        ],
        [
          -260.181640625,
          -2314.302490234375,
          638.002197265625
        ]
      ],
      "plane_distance": 638.5691,
      "authentic_texture": "doorjam"
    }
  ],
  "tutorial_messages": []
}